import React, { useEffect, useState } from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import CustomFieldValue from "@mapmycustomers/shared/types/customField/CustomFieldValue";
import { OptionalFields } from "@mapmycustomers/shared/util/ts";

import CustomFieldComponent from "@app/component/CustomField";
import layout from "@app/styles/layout";
import { NEGATIVE_ENTITY_ID } from "@app/util/consts";
import { getCustomFieldDataTypeDisplayName } from "@app/util/ui";

import styles from "./CustomFieldTest.module.scss";

interface Props {
  customField: CustomField;
  label?: string;
  showTypeTitle?: boolean;
}

const CustomFieldTest: React.FC<Props> = ({ customField, label, showTypeTitle }) => {
  const intl = useIntl();

  const [, setValue] = useState<OptionalFields<CustomFieldValue, "id">>();

  useEffect(() => {
    setValue({
      crmPropertyKey: "",
      currencyId: customField.currencyId,
      customField: { ...customField, id: NEGATIVE_ENTITY_ID },
      dataType: customField.dataType,
      esKey: customField.esKey,
      options: [],
      value: [],
    });
  }, [customField, setValue]);

  return (
    <div className={styles.container}>
      {showTypeTitle && (
        <Row gutter={layout.spacerM}>
          <Col className={styles.title}>
            {intl.formatMessage(
              {
                id: "settings.customFields.createEditPane.customFieldTest.title",
                defaultMessage: "{type} Field",
                description: "Settings Custom field - create/edit - custom field preview title",
              },
              { type: getCustomFieldDataTypeDisplayName(intl, customField.dataType) }
            )}
          </Col>
          <Col>
            <Tag>
              {intl.formatMessage({
                id: "settings.customFields.createEditPane.customFieldTest.tagText",
                defaultMessage: "Example",
                description: "Settings Custom field - create/edit - custom field preview tag text",
              })}
            </Tag>
          </Col>
        </Row>
      )}
      <div className={styles.preview}>
        <CustomFieldComponent
          definition={customField}
          label={
            label ??
            intl.formatMessage({
              id: "settings.customFields.createEditPane.customFieldTest.fieldName",
              defaultMessage: "Field name",
              description: "Settings Custom field preview name",
            })
          }
          onChange={setValue}
          tabIndex={-1}
        />
      </div>
    </div>
  );
};

export default CustomFieldTest;
